import Axios from "../utils/axiosInstance";
import {
  createTask,
  createTaskAPI,
  postCreateTask,
  updateTask,
  updateTaskAPI,
  putUpdateTask,
  getAllTasks,
  getAllTasksAPI,
  getTaskListById,
  getTaskListByIdAPI,
} from "./AllTaskTrackerAPI";

// Helper to retrieve and sanitize Bearer token
const getAuthToken = () => {
  let token =
    sessionStorage.getItem("token") ||
    localStorage.getItem("token") ||
    sessionStorage.getItem("Token") ||
    localStorage.getItem("Token") ||
    sessionStorage.getItem("jwt") ||
    localStorage.getItem("jwt");

  if (!token) return null;
  token = String(token).replace(/^["']|["']$/g, "").trim();
  if (!token || token === "null" || token === "undefined") return null;
  return token.startsWith("Bearer ") ? token : `Bearer ${token}`;
};

// API for creating new project:
export const createProject = (payload, pkUserId, role, headers) => {
  const authToken = getAuthToken();
  let queryUserId = pkUserId || sessionStorage.getItem("pkUserId") || "5cb01090-dfec-4710-88c1-1a4b8cc527e2";
  let queryRole = role || sessionStorage.getItem("role") || "Manager";

  const authHeaders = {
    "Content-Type": "application/json",
    ...(authToken ? { Authorization: authToken } : {}),
  };

  return Axios.post(`/projects/createProject`, payload, {
    params: { pkUserId: queryUserId, role: queryRole },
    headers: headers || authHeaders,
  });
};

// API for getting all projects: 
export const getAllProjects = (pkUserId, role, headers) => {
  const authToken = getAuthToken();
  let queryUserId = pkUserId || sessionStorage.getItem("pkUserId") || "5cb01090-dfec-4710-88c1-1a4b8cc527e2";
  let queryRole = role || sessionStorage.getItem("role") || "Manager";

  const authHeaders = authToken ? { Authorization: authToken } : {};

  return Axios.get(`/projects/getAllProjectList`, {
    params: { pkUserId: queryUserId, role: queryRole },
    headers: headers || authHeaders,
  });
};

// API for updating project: 
export const updateProject = (projectId, payload, pkUserId, role, headers) => {
  const authToken = getAuthToken();
  let queryUserId = pkUserId || sessionStorage.getItem("pkUserId") || "5cb01090-dfec-4710-88c1-1a4b8cc527e2";
  let queryRole = role || sessionStorage.getItem("role") || "Manager";

  const authHeaders = {
    "Content-Type": "application/json",
    ...(authToken ? { Authorization: authToken } : {}),
  };

  return Axios.put(`/projects/updateProject/${projectId}`, payload, {
    params: { pkUserId: queryUserId, role: queryRole },
    headers: headers || authHeaders,
  });
};

// Backward-compatible aliases for task tracker components
export const postCreateProject = createProject;
export const createProjectAPI = createProject;
export const getAllProjectsAPI = getAllProjects;
export const putUpdateProject = updateProject;
export const updateProjectAPI = updateProject;

// Re-export task APIs
export {
  createTask,
  createTaskAPI,
  postCreateTask,
  updateTask,
  updateTaskAPI,
  putUpdateTask,
  getAllTasks,
  getAllTasksAPI,
  getTaskListById,
  getTaskListByIdAPI,
};

export const AllProjectTrackerAPI = {
  createProject,
  getAllProjects,
  updateProject,
  postCreateProject,
  createProjectAPI,
  getAllProjectsAPI,
  putUpdateProject,
  updateProjectAPI,
  createTask,
  createTaskAPI,
  postCreateTask,
  updateTask,
  updateTaskAPI,
  putUpdateTask,
  getAllTasks,
  getAllTasksAPI,
  getTaskListById,
  getTaskListByIdAPI,
};

export default AllProjectTrackerAPI;
